





























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ProductPricing from '@/store/entities/product-pricings/create-product-pricing'
import AppConsts from '@/lib/appconst';
import _ from 'lodash';
import moment from "vue-moment";
Vue.use(require("vue-moment"));
 @Component
export default class CreateProductPricing extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    productPricing:ProductPricing=new ProductPricing();
    spinShow=false;
    effectiveDate : string="";
    productName: string="";
    clientCode :string="";
    objectLoading:boolean=false;
    clients=[];
    pricingProfiles=[];
    pricingTerms=[];
    products=[];
    searchProduct_OnPress =   _.debounce(this.searchProductForSelect, AppConsts.debounceDelayTime, {
        leading: false,
        trailing: true,
    });
    get client() {
      return this.$store.state.session.client;
    }
    isClient() {
      return  !Util.isNull(this.$store.state.session.client);
    }
     getClients(){
        var re = this.$store.state.client.clientsForSelect;
        this.clientCode = re.length === 0 ? "" : re[0].code;
        this.clients= re;
    }
    
    async getClientPricingProfiles()
    {
         await this.$store.dispatch({
                type:'productPricing/getClientPricingProfiles',
                data: { clientCode:this.clientCode, hasAllItem: false}
            })
            .then((result) => {
                this.pricingProfiles = result;
                this.productPricing.pricingProfileId = this.pricingProfiles.length === 0 ? 0 : this.pricingProfiles[0].id;
                this.changeProfile();
            });
    }
     async getPricingTerms()
    {
         await this.$store.dispatch({
                type:'productPricing/getPricingTerms',
                data: {  hasAllItem: false}
            })
            .then((result) => {
                this.pricingTerms = result;
                this.productPricing.pricingTermCode = this.pricingTerms.length === 0 ? "" : this.pricingTerms[0].id;
            });
    }
    async changeClientCode()
    {
        await this.getClientPricingProfiles();
    }
    changeProfile()
    {
        var profile = _.find(this.pricingProfiles,['id', this.productPricing.pricingProfileId]);
        if(Util.isNull(profile))
        {
            this.effectiveDate="";
        }
        else
        {
            this.effectiveDate= Util.toViewDatePickerString( profile.effectiveDate);
        }
    }
     async searchProductForSelect(keyword)
    {
        if(Util.isEmpty(keyword) || keyword.length<AppConsts.keyWordAtleastLength)
            return;
        this.objectLoading= true;
        this.products = await this.$store.dispatch({
                type:'product/searchProductForSelect',
                data: {
                    clientCode:this.clientCode,
                    keyWord:keyword
                }
        });
        this.objectLoading= false;
    }
    changeProduct()
    {
         if (Util.isNull(this.productPricing.productId) || this.productPricing.productId<=0) {
            this.productName = '';
            return;
        } 
        var product = _.find(this.products,['id', this.productPricing.productId]);
        if(Util.isNull(product))
        {
            this.productName='';
            Util.showErrorMsg(this,"Error.ProductNotExist");
            return;
        }
        this.productName= product.name;
    }
    reset()
    {
        this.productPricing = new ProductPricing();
        this.clientCode= "";
        this.effectiveDate =null;
        this.productName = "";
        this.clients = [];
        this.objectLoading = false;
        this.pricingTerms = [];
        this.pricingProfiles = [];
        this.products=[];
    }
    cancel() {
        (this.$refs.productPricingForm as any).resetFields();
        this.$root.$router.push({ name: "productpricing" });
    }
     async save() {
         (this.$refs.productPricingForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.$Modal.confirm({
                    title:this.L('Tips'),
                    content:this.L('Confirm.CreateProductPricing'),
                    okText:this.L('Yes'),
                    cancelText:this.L('No'),
                    onOk:async()=>{
                        this.spinShow=true;
                        try {
                            await this.$store.dispatch({
                                type: "productPricing/create",
                                data: this.productPricing
                                }) 
                                .then(result => {
                                Util.showSuccessMsg(this,"Success.CreateProductPricing");
                                this.reset();
                                this.cancel();
                            });
                            this.spinShow=false;
                        } catch (error) {
                        this.spinShow=false; 
                        }
                    }
                });
            }
        });
        
    }
    async created(){
        this.spinShow = true;
        try {
            if(this.isClient())
            {
                this.clientCode = this.client.code;
            }
            else
            {
                 await this.$store.dispatch({
                    type:'client/getListForSelect'
                }).then(result=>{
                    this.getClients();
                });
            }
            await this.getPricingTerms();
            await this.getClientPricingProfiles();
            this.spinShow=false;
        } catch (error) {
            this.spinShow=false;
        }
    }
    productPricingRule = {
        clientCode: [
            {
                required: true,
                message: this.L("Error.RequiredField", undefined, this.L("Client")),
                trigger: "blur"
            }
        ],
        pricingTermCode: [
            {
                required: true,
                message: this.L("Error.RequiredField", undefined, this.L("PricingTerm")),
                trigger: "blur"
            }
        ],
        pricingProfileId: [
            {
                required: true,
                type:'number',
                message: this.L("Error.RequiredField", undefined, this.L("PricingProfile")),
                trigger: "blur"
            }
        ],
        productId: [
            {
                required: true,
                type:'number',
                message: this.L("Error.RequiredField", undefined, this.L("Product")),
                trigger: "blur"
            }
        ],
        price: [
            {
                required: true,
                type:'number',
                message: this.L("Error.RequiredField", undefined, this.L("Price")),
                trigger: "blur"
            }
        ]
    };
}
